var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"inoZlGjyZC6XEQYIY3tvq"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN

Sentry.init({
    dsn: SENTRY_DSN || 'https://d8c3280587a54339bc2b4aa63a4a0d3b@o1211948.ingest.sentry.io/4504135600439296',
    // Adjust this value in production, or use tracesSampler for greater control
    environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
    replaysSessionSampleRate: 0.05,
    tracesSampler: (samplingContext) => {
        if (
            samplingContext.transactionContext.name === 'GET /health-check' ||
            process.env.NEXT_PUBLIC_ENVIRONMENT === 'local'
        ) {
            return 0
        }
        return 0.1
    },
    integrations: [new Sentry.Replay()],
    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
})
